<template>
  <div class="main">
    <img
      class="not_banner"
      :src="`${cdnresources}/uat/images/xiangaibao/topbg.png`"
    />
    <img
      class="not_banner1"
      :src="`${cdnresources}/prod/images/xiangaibao/img.png`"
    />
    <template v-if="showCode">
      <img
        class="not_banner2"
        :src="`${cdnresources}/uat/images/xiangaibao/img1.png`"
      />
      <img class="wxCode" src="@/assets/img/pay/wxCode.png" alt="" />
    </template>
    <div class="but" @click="toJoin">继续为家人投保</div>
  </div>
</template>

<script>
  import { gethttpurl, getDeviceInfo } from '@/util/tools'
  import { cdnresources } from '@/util/config'
  import { SetLeChengShare } from '@/util/set-wx-share'
  import { bdPromotion } from '@/api/pay'
  import { FindInsurancePayOrderByOrderSn } from '@/api/user'
  import rrwebSDK from '@/util/rrweb.sdk-1.2.0'
  export default {
    name: 'BuySuccess',
    components: {},
    filters: {},
    mixins: [],
    props: {},
    data() {
      return {
        cdnresources,
        payType: '',
        show: false,
        platInfo: getDeviceInfo(),
        rrwebSDK: null,
        showCode: true
      }
    },
    computed: {},
    watch: {
      $route: {
        handler: function(newVal, oldVal) {
          if (newVal.fullPath !== oldVal.fllPath) {
            this.initPage()
          }
        }
      }
    },
    beforeCreate() {
      this.rrwebsdk = new rrwebSDK()
      this.rrwebsdk.start() // 开始录制
    },
    created() {
      this.getUserOrderInfo()
    },
    mounted() {
      this.payType = this.$route.query.payType
      if (this.payType === 'alipayAcc') {
        // 支付方式为支付宝时做埋点
        // eslint-disable-next-line no-undef
        __bl.api({ api: '成功投保', success: true, c1: 'taSR_YL', time: 0 })
        // eslint-disable-next-line no-undef
        // __bl.api({api:"成功投保",success:true,c1:"taSR_YL"})
      }
      this.initPage()
      // 支付成功后调用百度营销
      let baiduCodeList = ['market000001', 'market000002', 'market000003']
      if (baiduCodeList.includes(this.$route.query.fromSourceCode)) {
        const bdPromotionUrl = sessionStorage.getItem('bdPromotion')
        let bdObj = {
          url: bdPromotionUrl,
          productCode: this.$route.query.baosicode,
          fromSourceCode: this.$route.query.fromSourceCode
        }
        bdPromotion(bdObj)
          .then(res => {
            console.log('##############', res)
          })
          .catch(e => {
            console.log('@!!!!!!!!!!', e)
          })
      }
      // 快手埋点
      if (gethttpurl('fromSourceCode') == 'market000005') {
        let data = JSON.parse(sessionStorage.getItem('KSParams'))
        data.url = location.href
        bdPromotion(data)
          .then(res => {
            console.log('KSParams----------res-------->', res)
          })
          .catch(e => {
            console.log('KSParams----------error------->', e)
          })
      }
      if (this.$route.query.fromSourceCode === 'market000004') {
        // 支付成功后调用头条埋点
        // 调用本地埋点服务
        const bdPromotionUrl = sessionStorage.getItem('bdPromotion')
        console.log(bdPromotionUrl)
        let bdObj = {
          url: bdPromotionUrl
        }
        bdPromotion(bdObj).then(res => {
          console.log(res)
        })
      }
      // 支付宝渠道去除二维码显示
      let codeList = ['yxhb00000173', 'yxhb00000211']
      if (codeList.includes(this.$route.query.fromSourceCode)) {
        this.showCode = false
      }
    },
    destroyed() {
      sessionStorage.removeItem('bdPromotion')
      this.rrwebsdk.leaveReport(() => {})
    },
    methods: {
      async initPage() {
        SetLeChengShare()
      },
      async getUserOrderInfo() {
        try {
          let orderNo = localStorage.getItem('orderSn')
          let res = await FindInsurancePayOrderByOrderSn({
            orderSn: orderNo
          })
          this.rrwebsdk.report({
            goodsName: '湖南爱民保2022', // 产品名称
            goodsCode: 'HNAMB2022', // 产品编码
            origin: 'HMB', // 来源，可在后台字典中配置
            applicantName: res.insureEn.appntName, // 投保人姓名
            idNo: res.insureEn.appntIdNo, // 投保人证件号
            orderNo: orderNo, // 订单号
            goodsVersion: '1.0.0'
          })
        } catch (e) {
          console.log('e--获取用户信息', e)
        }
      },
      toJoin() {
        this.$router.push({
          path: '/area-insu-buy-detail',
          query: {
            fromSourceCode: this.$route.query.fromSourceCode,
            baosicode: this.$route.query.baosicode
          }
        })
        //  window.location.href = 'https://test.yuanxinbaoxian.com/hunan_mobile/index.html?baosicode=1#/area-insu-buy-detail'
      }
    }
  }
</script>
<style lang="scss" scoped>
  .main {
    text-align: center;
    position: relative;
    .but {
      width: xvw(420);
      height: px2rem(100);
      background: linear-gradient(to right, #ff7828, #ff282c);
      border-radius: px2rem(60);
      border-color: #edeef2;
      color: #ffffff;
      line-height: px2rem(100);
      margin: xvw(40) auto;
      font-size: xvw(30);
    }
  }
  .wxCode {
    width: xvw(130);
    position: absolute;
    left: xvw(94);
    top: xvw(905);
  }
  .wxqrcode {
    margin-top: 8vh;
    display: flex;
    font-size: 3vw;
    img {
      width: 60%;
    }
    dd,
    p {
      margin: 0px;
    }
    dt img {
      width: 64.4%;
    }
  }
  .stateP {
    color: #000;
    font-size: 14px;
    line-height: 30px;
    text-align: left;
  }
  .not_banner {
    width: 100%;
  }
  .not_banner1 {
    width: 70%;
    margin-top: xvw(12);
  }
  .not_banner2 {
    width: 86%;
    margin-top: xvw(70);
  }

  .centent_img {
    text-align: center;
    padding: 0px 6vw;
    font-size: pxrem(28);
    line-height: pxrem(60);
    color: #000;
    .text1 {
      .num {
        font-size: 50px;
        font-weight: bold;
        color: #ea332b;
      }
      .text {
        font-size: 22px;
        font-family: SourceHanSansCN-Bold, SourceHanSansCN;
        font-weight: bold;
        color: #333333;
        line-height: 40px;
      }
    }
    .text2 {
      font-size: 19px;
      font-weight: bold;
      color: #ea332b;
      line-height: 33px;
      background: #fff1f1;
      width: 58%;
      margin: 0 auto;
    }
    .flexbox {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: center;
      font-size: 16px;
      font-weight: 400;
      color: #333333;
      .flexlist {
        margin-top: 8px;
        img {
          width: 26px;
          vertical-align: sub;
        }
      }
    }
    .tipdiv {
      background: #fff1f1;
      border-radius: 12px;
      padding: 12px;
      .tipbox {
        display: flex;
        justify-content: space-between;
        .tip1 {
          font-size: 22px;
          color: #730d07;
          line-height: 30px;
          letter-spacing: 2px;
          font-weight: bold;
        }
        .tip2 {
          font-size: 18px;
          font-family: SourceHanSansCN-Bold, SourceHanSansCN;
          font-weight: bold;
          color: #730d07;
          line-height: 50px;
          letter-spacing: 1px;
          display: inline-block;
        }
        .imgbox {
          width: 110px;
          img {
            width: 100%;
          }
        }
      }
      .codebox {
        display: flex;
        justify-content: space-between;
        background: #fff;
        padding: 10px;
        .imgbox {
          width: 120px;
          img {
            width: 100%;
          }
        }
        .textbox {
          text-align: left;
          .span1 {
            font-size: 16px;
            font-weight: 700;
            color: #ea332b;
            line-height: 45px;
            letter-spacing: 1px;
          }
          .span2 {
            font-size: 16px;
            font-weight: 500;
            color: #333333;
            line-height: 40px;
            letter-spacing: 1px;
            display: inline-block;
          }
        }
      }
    }
  }
</style>
